import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-geoastra-gnss-receivers',
  templateUrl: './geoastra-gnss-receivers.component.html',
  styleUrls: ['../landing/landing.component.scss', '../landing/headers.css', './geoastra-gnss-receivers.component.scss']
})
export class GeoAstraGnssReceiversComponent implements OnInit, OnDestroy {
  lightboxOpen = false;
  lightboxSrc = '';
  lightboxAlt = '';

  readonly buyUrls = {
    x8m1:
      'https://gpswebshop.com/products/bynav-m8-x1-tri-band-rtk-bluetooth-gnss-receiver-1-cm-accuracy-full-constellation-and-full-frequence-support-bluetooth-5-1-4g-lte-network-compatibility-ip67-waterproof-20-hour-battery-life-ultra-portable-at-only-104g',
    rtu609bt:
      'https://gpswebshop.com/products/geoastra-rtu609bt-high-precision-positioning-and-heading-gnss-receiver-dual-rtk-engine-dual-antenna-bluetooth-and-usb-dual-interfaces-l1-l2-and-l5-tri-band-up-to-0-8-cm-position-accuracy-and-0-2-direction-accuracy',
    rtu608bt:
      'https://gpswebshop.com/products/geoastra-rtu608bt-industrial-grade-usb-bluetooth-rtk-gnss-receiver-zed-f9p-multi-band-rtk-30-cm-standalone-accuracy-up-to-1-4-cm-with-rtk-nylon-braided-usb-cable-ip67-waterproof-operating-temperature-40-to-85',
    y55g:
      'https://gpswebshop.com/products/geoastra-a2-rtk-ppp-gnss-android-14-device-1cm-rtk-accuracy-20cm-ppp-accuracy-has-b2b-satellite-corrections-full-band-l1-l2-l5-e6-b2b-google-play-gms-supported',
    gc9140kb:
      'https://gpswebshop.com/products/geoastra-gc-9140kb-industrial-grade-usb-c-gnss-receiver-usb-type-c-25-hz-update-rate-ip67-waterproof-full-constellation-support-u-blox-m9140-kb-chip'
  };

  private fragSub: Subscription | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.fragSub = this.route.fragment.subscribe((frag) => {
      if (!frag) {
        return;
      }
      setTimeout(() => this.scrollTo(frag), 80);
    });
  }

  ngOnDestroy(): void {
    this.fragSub?.unsubscribe();
  }

  scrollTo(anchorId: string): void {
    document.getElementById(anchorId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  openLightbox(src: string, alt: string): void {
    this.lightboxSrc = src;
    this.lightboxAlt = alt;
    this.lightboxOpen = true;
  }

  closeLightbox(): void {
    this.lightboxOpen = false;
    this.lightboxSrc = '';
    this.lightboxAlt = '';
  }

  openExternal(url: string): void {
    const win = window.open(url, '_blank', 'noopener');
    if (win) {
      win.opener = null;
    }
  }
}
